'use strict';
angular.module("iconoglobe")
    .controller('LoginCtrl', LoginCtrl);
LoginCtrl.$inject = ['$scope', '$http', '$location', '$stateParams', '$state', "$rootScope", "$filter", "localStorageService", "toastService", "$auth", "$uibModal", "cookieStore"];

function LoginCtrl($scope, $http, $location, $stateParams, $state, $rootScope, $filter, localStorageService, toastService, $auth, $uibModal, cookieStore) {
    $scope.selectedPage = $state.$current.url.pattern;
    $scope.loginData = {};
    $scope.emailErr = '';
    $scope.resetData = {};
    $scope.contactData = {};
	$scope.investData = {};
	$scope.eeslct = {};
    $scope.forgetsuccess = false;
    $scope.forgetERROR = false;
    var rand_id = $location.path();
    var check = rand_id.split('/');
    if (check[1] == 'login' && check[3] != undefined) {
        $http.post('/api/checkrandomnumber', {
            rand_id: rand_id
        }).then(function(res) {
          //  console.log(res);
            if (res.data == 1) {
                $location.path("/profile");
            } else if (res.data == 2) {
                var message = 'You are unauthorised user';
                $location.path('/login');
            } else {
                var message = $filter('translate')('views.Youhavealreadyconfirmed');
                $location.path('/login');
            }
        }, function(err) {});
    }

  function getUserCategory() {
            $scope.usercategory = [
    {
        "id": 1,
        "value": "Individual"
    },
    {
        "id": 3,
        "value": "Promoter"
    },
    {
        "id": 5,
        "value": "Performer/Entertainer"
    },
    {
        "id": 7,
        "value": "Scholastic Department"
    },
    {
        "id": 2,
        "value": "Establishment"
    },
    {
        "id": 4,
        "value": "Event Center"
    },
    {
        "id": 6,
        "value": "Government Department"
    }
]; 
  };
    var open = "closed";

    /*
        Primary resources that needs to be loaded first to show appropriate page to user (specially first time user) have been loaded.
        Now do other tasks important for adding other features to page
    */
    $rootScope.$on('primaryResourcesLoaded', function() {
       // console.log("LoginCtrl->$on[primaryResourcesLoaded]");
        getUserCategory();
    });
    $scope.openModeForSignUpAs = function(res) {
        $scope.facebookResponse = res;
        $scope.modalInstance = $uibModal.open({
            templateUrl: 'app/min/sinupas-modal.html',
            controller: 'LoginCtrl',
            windowClass: 'zindexModal int39',
            controllerAs: '$ctrl',
            scope: $scope,
            resolve: {}
        });
    };
    $scope.cancel = function() {
        $scope.modalInstance.close();
    };
    $scope.regData = {};
    $scope.ok = function() {
        if ($scope.regData.user_category == '' || $scope.regData.user_category == undefined) {} else if ($rootScope.loginWith == "facebook") {
            $http.post('/api/registerFacebook', {
                register: $rootScope.facebookRes,
                category: $scope.regData.user_category,
                username: $scope.regData.username
            }).then(function(res) {
                localStorageService.set('name', res.data.name);
                localStorageService.set('usercategory', res.data.usercategory);
                $rootScope.usercategory = res.data.usercategory;
                $rootScope.loggedusername = res.data.msg;
                $scope.errorLogginIn = false;
                $rootScope.usercategory = res.data.usercategory;
                angular.element('#loading').addClass('hide');
                $scope.modalInstance.close();
                $location.path("/profile");
            });
        } else if ($rootScope.loginWith == "google") {
            //console.log({register: $rootScope.googleRes,category: $scope.regData.user_category,username: $scope.regData.username});
            return;
            $http.post('/api/registerGoogle', {
                register: $rootScope.googleRes,
                category: $scope.regData.user_category,
                username: $scope.regData.username
            }).then(function(res) {
                localStorageService.set('name', res.data.name);
                localStorageService.set('usercategory', res.data.usercategory);
                $rootScope.usercategory = res.data.usercategory;
                $rootScope.loggedusername = res.data.msg;
                $scope.errorLogginIn = false;
                $rootScope.usercategory = res.data.usercategory;
                angular.element('#loading').addClass('hide');
                $scope.modalInstance.close();
                $location.path("/profile");
            });
        } else if ($rootScope.loginWith == "VK") {
            $http.post('/api/registerVK', {
                register: $scope.weiboRes,
                category: $scope.regData.user_category,
                username: $scope.regData.username
            }).then(function(res) {
                localStorageService.set('name', res.data.name);
                localStorageService.set('usercategory', res.data.usercategory);
                $rootScope.usercategory = res.data.usercategory;
                $rootScope.loggedusername = res.data.msg;
                $scope.errorLogginIn = false;
                $rootScope.usercategory = res.data.usercategory;
                angular.element('#loading').addClass('hide');
                $scope.modalInstance.close();
                $location.path("/profile");
            });
        } else if ($rootScope.loginWith == "Simple Login") {
            $http.post('/api/updateUserCategory', {
                username: $scope.regData.username_c,
                category: $scope.regData.user_category,
                email: $rootScope.loggedusername
            }).then(function(res) {
                angular.element('#loading').addClass('hide');
                $scope.modalInstance.close();
                $location.path("/profile");
            });
        }
    };

    $scope.authenticate = function(provider) {
        $rootScope.facebookRes = [];
        $rootScope.googleRes = [];
        $rootScope.loginWith = '';
        $auth.authenticate(provider)
            .then(function(response) {
                if (provider == "facebook") {
                    var accessToken = response.access_token;
                    $http.get('https://graph.facebook.com/me?fields=id,email,first_name,last_name,gender,location&access_token=' + accessToken).then(function(res) {
                        $rootScope.facebookRes = res;
                        $rootScope.loginWith = "facebook";
                        $http.post('/api/login/social', {
                            email: res.data.email
                        }).then(function(resp) {
                            var data = resp.data;
                            if (data.status == 1) {
                                var name = data.user.first_name + " " + data.user.last_name;
                                localStorageService.set('name', name);
                                localStorageService.set('usercategory', data.user.category);
                                $rootScope.usercategory = data.user.category;
                                $rootScope.loggedusername = data.user.email;
                                $scope.errorLogginIn = false;
                                angular.element('#loading').addClass('hide');
                                $location.path("/profile");
                            } else {
                                var msg = $filter('translate')('views.invalidusername');
                                toastService.create(msg, 'down', 'danger', 3000);
                            }
                        });
                    });
                }
                if (provider == "google") {
                    var url = "https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token=" + $auth.getToken();
                    $http.get(url).then(function(res) {
                        $rootScope.googleRes = res;
                        $rootScope.loginWith = "google";
                        if (!res.data.email) {
                            var msg = $filter('translate')('views.erroroccurred');
                            toastService.create(msg, 'down', 'danger', 3000);
                            return;
                        }
                        $http.post('/api/login/social', {
                            email: res.data.email
                        }).then(function(resp) {
                            var data = resp.data;
                            if (data.status == 1) {
                                var name = data.user.first_name + " " + data.user.last_name;
                                localStorageService.set('name', name);
                                localStorageService.set('usercategory', data.user.category);
                                $rootScope.usercategory = data.user.category;
                                $rootScope.loggedusername = data.user.email;
                                $scope.errorLogginIn = false;
                                angular.element('#loading').addClass('hide');
                                $location.path("/profile");
                            } else {
                                var msg = $filter('translate')('views.invalidusername');
                                toastService.create(msg, 'down', 'danger', 3000);
                            }
                        });
                    });
                }
                if (provider == "spotify") {
                    var accessToken = response.access_token;
                    var email = response.email;
                    $scope.weiboRes = response;
                    $rootScope.loginWith = "VK";
                    $http.post('/api/login/social', {
                        email: email
                    }).then(function(resp) {
                        var data = resp.data;
                        if (data.status == 1) {
                            var name = data.user.first_name + " " + data.user.last_name;
                            localStorageService.set('name', name);
                            localStorageService.set('usercategory', data.user.category);
                            $rootScope.usercategory = data.user.category;
                            $rootScope.loggedusername = data.user.email;
                            $scope.errorLogginIn = false;
                            angular.element('#loading').addClass('hide');
                            $location.path("/profile");
                        } else {
                            var msg = $filter('translate')('views.invalidusername');
                            toastService.create(msg, 'down', 'danger', 3000);
                        }
                    });
                }
            })
            .catch(function(response) {
                // Something went wrong.
            });
    };
    $scope.userCategory = function() {
       /* $("html, body").animate({
            scrollTop: 0
        }, "slow");*/
        var selectedVal = $scope.regData.user_category;
        $scope.isVisible = true;
        if (selectedVal == 2) {
            angular.element("label[for=username]").html($filter('translate')('views.establishment_name') + "<span class='required'>*</span>");
        } else if (selectedVal == 6) {
            angular.element("label[for = username]").html($filter('translate')('department_name') + "<span class='required'>*</span>");
        } else if (selectedVal == 4) {
            angular.element("label[for = username]").html($filter('translate')('eventcentname') + "<span class='required'>*</span>");
        } else if (selectedVal == 5) {
            angular.element("label[for = username]").html($filter('translate')('performer/entertainer/group_name') + "<span class='required'>*</span>");
        } else if (selectedVal == 3) {
            angular.element("label[for = username]").html($filter('translate')('promonmes') + "<span class='required'>*</span>");
        } else if (selectedVal == 7) {
            angular.element("label[for = username]").html($filter('translate')('scholastic_institution_name') + "<span class='required'>*</span>");
        } else if (selectedVal == 1) {
            $scope.isVisible = false;
        }
        angular.element('#registerreg_form').removeClass('hide');
        angular.element('#social_login_btns').removeClass('hide');
        angular.element('#user_cat').removeClass('show');
        angular.element('#user_cat').addClass('hide');
        $scope.regData.username = '';
        $scope.regData.city = '';
        angular.element('#country').val('');
        angular.element('#state').val('');
        $scope.regData.first_name = '';
        $scope.regData.last_name = '';
        $scope.regData.member_email = '';
        $scope.regData.email = '';
        $scope.regData.password = '';
        $scope.reenter_password = '';
        $scope.regData.terms = '';
        $scope.regData.promoter_name = '';
        if ($scope.regForm)
            $scope.regForm.$setPristine();
    };
    $scope.login = function(valid) {
      //  console.log("login", $rootScope.notification);
        $scope.submitted = true;
        if (valid == true) {
            angular.element('#loading').removeClass('hide');
            $http.post('/api/login', {
                login: this.loginData
            }).then(function(res) {
                if (res.data.status == 3 || res.data.status == 4 || res.data.status == 5) {
                    angular.element('#loading').addClass('hide');
                    $scope.errorLogginIn = true;
                } else if (res.data.status == 6) {
                    $scope.emailErr = $filter('translate')("views.verify_email");
                    toastService.create($scope.emailErr, 'down', 'danger', 5000);
                    angular.element('#loading').addClass('hide');
                } else {
                    localStorageService.set('name', res.data.name);
                    localStorageService.set('usercategory', res.data.usercategory);
                   // traceLog('user-login', 'response of login is ', res.data)
                    $rootScope.usercategory = res.data.usercategory;
                    $rootScope.loggedusername = res.data.msg;
                    $scope.errorLogginIn = false;
                    $rootScope.usercategory = res.data.usercategory;
                    $location.path("/profile");
                    setTimeout(function () {angular.element('#loading').addClass('hide'); }, 4000);
                    
                   
                }
            }, function(err) {});
        }
    };
    $scope.getClass = function(menu) {
        return menu === $location.path();
    };
    $scope.changePage = function(path) {
        $location.path(path);
    };
    $scope.getCurrentPageName = function() {
        var currentPath = $location.path();
		  let casePath; 
          let nextDelimiter = 0;
          let secondDelimiter = 2;
          for (let secondDelimiterCharPos = 0; secondDelimiterCharPos < currentPath.length;           secondDelimiterCharPos++){
          if (currentPath[secondDelimiterCharPos] === '/'){
           nextDelimiter++
          if (nextDelimiter === secondDelimiter){
        casePath = currentPath.substring(0,secondDelimiterCharPos);
        currentPath = casePath;
      }
		  }}
        switch (currentPath) {
            case '/profile':
                return 'views.primary_profile';
            case '/notify':
                return 'views.Notifications';
			case '/addnotify':
                return 'views.Notifications';
            case '/addphoto':
                return 'views.Photos';
            case '/comments':
                return 'views.Comments';
            case '/view-registrations':
                return 'views.Register_establishment/events';
            case '/personalizedicon':
                return 'views.PersonalizedIcon';
            case '/mediagallery':
                return 'views.mediagallery';
            case '/audiogallery':
                return 'views.Audiogallery';
            case '/videogallery':
                return 'views.Videogallery';
            case '/establishment':
                return 'views.add_establishment';				
            case '/editesta':
                return 'views.Establishment';
            case '/livevideo':
                return 'views.livevideodescription';
            case '/entertainment':
                return 'views.Establishment';
            case '/eventview':
                return 'views.UpcomingEvents';
			 case '/ineventview':
                return 'views.UpcomingEvents';
            case '/public-comments':
                return 'views.comments_from_public';
            case '/payments':
                return 'views.Transactions';
            case '/promotions':
                return 'views.PromotionInformation';
            case '/addestablishment':
                return 'views.add_establishment';
            case '/addpromotion':
                return 'views.add_promotions';
            case '/addevent':
                return 'views.AddEventsDetails';
			case '/liveevent':
                return 'views.golive';
			case '/indivevent':
                return 'views.golive';
            case '/eventedit':
                return 'views.EditEvents';
            case '/uploadphotos':
                 return 'views.UploadPhotos';
            case'/livevideo':
                return 'views.livestream';
            case'/editesta':
                return 'views.Establishment';
            case '/uploadaudios':
                return 'views.UploadAudios';
            case '/uploadvideos':
                return 'views.UploadVideos';
            default:
                'views.primary_profile';
        }
    };
    
	
 
    $scope.eeslct = function(eslct) {
        if (angular.element('.nav-icon').hasClass('open')) {
    angular.element('.nav-icon').removeClass('open');
    angular.element('.serg-popup-menu-wrap').removeClass('active');
    angular.element('body#body').css('overflow-y', 'scroll');
}
      if (angular.element('#eeslct').hasClass('eeexp')) {
            angular.element('#eeslct').removeClass('eeexp');
        } else {
           angular.element('#eeslct').addClass('eeexp');
        }
        
         if (angular.element('#menuclk').hasClass('eeexp')) {
            angular.element('#menuclk').removeClass('eeexp');
        } else {
           angular.element('#menuclk').addClass('eeexp');
        }
         if (angular.element('#current-page-text').hasClass('eeexp')) {
            angular.element('#current-page-text').removeClass('eeexp');
        } else {
           angular.element('#current-page-text').addClass('eeexp');
        }
        
        
    };
	
	
	
	
	
	
	
	
	
	
	
	
	$scope.getNotifyClass = function(menu) {
        var currentPath = $location.path();
        var forActive = currentPath.split("/");
        if (forActive[1] === 'notify' || forActive[1] === 'addnotify') {
            return true;
        }
    };
    $scope.getRegClass = function(menu) {
        var currentPath = $location.path();
        var forActive = currentPath.split("/");
        if (forActive[1] === 'view-registrations' || forActive[1] === 'register-entertainment') {
            return true;
        }
    };
    var currentPath = $location.path();
    var forActive = currentPath.split("/");
    if (forActive[1] === 'entertainment' || forActive[1] === 'establishment' || forActive[1] === 'establishments' || forActive[1] === 'editesta') {
        angular.element('#entCls').addClass('active');
    } else if (forActive[1] === 'addevent' || forActive[1] === 'addevents' || forActive[1] === 'eventview' || forActive[1] === 'eventedit') {
        angular.element('#clsEve').addClass('active');
    }
    $scope.resetpassword = function(valid) {
        $scope.submitted = true;
        if (valid == true) {
            angular.element('#loading').removeClass('hide');
            var lang = cookieStore.getCookie("lang_pref");
            if (!lang) {
                lang = "en_US";
            }
            $http.post('/api/forgetpassword', {
                email: $scope.loginData.email,
                lang: lang
            }).then(function(res) {
               // console.log(res);
                if (res.data == 1) {
                    var message = $filter('translate')('views.Wehavesentemail');
                    toastService.create(message, 'down', 'success', 3000);
                    $scope.forgetsuccess = true;
                    $location.path('/login');
                } else {
                    angular.element('#loading').addClass('hide');
                    $scope.forgeterror = true;
                    $scope.emailErr = $filter('translate')("views.Emaildoesnotexists");
                    toastService.create($scope.emailErr, 'down', 'danger', 3000);
                }
            }, function(err) {});
        }
    };
    $scope.reset = function(valid) {
        $scope.submitted = true;
        if (valid == true) {
            angular.element('#loading').removeClass('hide');
            $scope.id = $stateParams.id;
            $scope.code = $stateParams.code;
            $http.post('/api/resetpassword', {
                id: $scope.id,
                code: $scope.code,
                password: this.resetData
            }).then(function(res) {
             //   console.log(res);
                if (res.data.status.count == 1) {
                    var message = $filter('translate')('views.Youhaveresetpassword');
					toastService.create(message, "down", "success", 5000);
                    $location.path('/login');
                } else {
                    angular.element('#loading').addClass('hide');
                    var message = $filter('translate')('views.Sorrylinkexpired');
                }
            }, function(err) {});
        }
    };
  /*  $scope.showMenus = function() {
        angular.element('.showmenu').removeClass('hide');
    };
    $scope.dropDownClick = function() {
        angular.element('.dropdownmenu').css('display', 'block');
        console.log("CLICK");
    }
    $scope.dropDownOver = function() {
        angular.element('.dropdownmenu').css('display', 'block');
        console.log("OVER");
    }

    $scope.dropDownLeave = function() {
        if (open == "closed") {
            angular.element('.dropdownmenu').css('display', 'none');
        } else if (open == "open") {
            angular.element('.dropdownmenu').css('display', 'block');
        }
    }*/
    
    
    
    
    let isHoveringLogin = false;
let isHoveringMenu = false;

$scope.dropDownOverLogin = function () {
    isHoveringLogin = true;

    var pst3 = document.getElementById('pst3');
    if (pst3) {
        pst3.classList.remove('active');
    }

    showMenu();
};

$scope.dropDownLeaveLogin = function () {
    isHoveringLogin = false;
    hideMenuIfNeeded();
};

$scope.dropDownOverMenu = function () {
    isHoveringMenu = true;
    showMenu();
};

$scope.dropDownLeaveMenu = function () {
    isHoveringMenu = false;
    hideMenuIfNeeded();
};

function showMenu() {
    angular.element('.dropdownmenu').css('display', 'block');
}

function hideMenuIfNeeded() {
    if (!isHoveringLogin && !isHoveringMenu) {
        angular.element('.dropdownmenu').css('display', 'none');
    }
}
    
    
    
    

    $scope.langSelectClick = function() {
        if (open == "closed") {
            open = "open";
        } else if (open == "open") {
            open = "closed";
        }

    }

    $scope.langSelectBlur = function() {
        if (open == "open") {
            open = "closed";
        } else {
            open = "closed";
        }

    }

    $scope.contact = function(valid) {
        $scope.submitted = true;
        if (valid == true) {
            $('#contact_send').attr('disabled', true);
            angular.element('#loading').removeClass('hide');
            var lang = cookieStore.getCookie("lang_pref");
            if (!lang) {
                lang = "en_US";
            }
            $http.post('/api/contact', {
                contact: $scope.contactData,
                lang: lang
            }).then(function(res) {
               // console.log(res);
                if (res.data == 1) {
                    $state.reload();
                    angular.element('#loading').addClass('hide');
                    // var message = "{{'views.Thankyoucontacting' | translate}}";
                    var message = $filter('translate')('views.Thankyoucontacting');
                    toastService.create(message, 'down', 'success', 7000);
                }
            }, function(err) {});
        }
    };
	    $scope.invest = function(valid) {
        $scope.submitted = true;
        if (valid == true) {
            $('#invest_send').attr('disabled', true);
            angular.element('#loading').removeClass('hide');
            var lang = cookieStore.getCookie("lang_pref");
            if (!lang) {
                lang = "en_US";
            }
            $http.post('/api/invest', {
                contact: $scope.contactData,
                lang: lang
            }).then(function(res) {
               // console.log(res);
                if (res.data == 1) {
                    $state.reload();
                    angular.element('#loading').addClass('hide');
                    // var message = "{{'views.Thankyoucontacting' | translate}}";
                    var message = $filter('translate')('views.ThankyouInvestor');
                    toastService.create(message, 'down', 'success', 9000);
                }
            }, function(err) {});
        }
    };
}


angular.module('iconoglobe')
    .directive('validateMatch', function() {
        return {
            require: 'ngModel',
            scope: {
                validateMatch: '='
            },
            link: function(scope, element, attrs, ngModel) {
                scope.$watch('validateMatch', function() {
                    ngModel.$validate(); // validate again when match value changes
                });
                ngModel.$validators.match = function(modelValue) {
                    if (!modelValue || !scope.validateMatch || ngModel.$error.minlength) {
                        return true;
                    }
                    ngModel.$setValidity('noMatch', modelValue === scope.validateMatch);
                    return modelValue === scope.validateMatch;
                };
            }
        };
    });

angular.element(document).ready(function() {

    angular.element(document).mouseup(function(e) {
        var container = angular.element('.dropdownmenu');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.hide();
        }
    });

});